package com.vizio.pay.api

import com.vizio.redwolf.pay.api.OffersApi
import com.vizio.redwolf.pay.api.OffersResult
import com.vizio.redwolf.pay.model.OfferDetailsByOfferIdRequestInfo
import com.vizio.redwolf.pay.model.OfferIdByLinkingPinRequestInfo
import com.vizio.redwolf.utils.AppConfig
import com.vizio.redwolf.utils.OffersEnvironment
import com.vizio.redwolf.utils.ResponseHeaders
import com.vizio.redwolf.utils.clientprovider.WebApiUseCase
import kotlin.js.Promise

@JsExport
class OffersJsApi(env: OffersEnvironment, jsClientConfig: JsClientConfig? = null) {
    private val offersApi = OffersApi(
        environment = env,
        appConfig = AppConfig(""),
        clientConfig = jsClientConfig.toClientConfig(WebApiUseCase.COOKIE_SDK_HEADERS)
    )

    @JsName("requestOfferDetailsByOfferId")
    fun requestOfferDetailsByOfferId(jsRequestInfo: dynamic, traceId: String? = null): Promise<dynamic> {
        return handleJsPromiseRequest(exceptionHandler = ::handleOffersJsException) {
            val requestInfo = OfferDetailsByOfferIdRequestInfo(
                offerId = jsRequestInfo.offerId as String,
                pin = jsRequestInfo.pin as String,
                accessToken = jsRequestInfo.accessToken as String
            )
            offersApi.requestOfferDetailsByOfferId(requestInfo, traceId = traceId)
        }
    }

    @JsName("requestOfferIdByLinkingPin")
    fun requestOfferIdByLinkingPin(jsRequestInfo: dynamic, traceId: String? = null): Promise<dynamic> {
        return handleJsPromiseRequest(exceptionHandler = ::handleOffersJsException) {
            val requestInfo = OfferIdByLinkingPinRequestInfo(
                linkingPin = jsRequestInfo.linkingPin as String?,
                deviceInstanceId = jsRequestInfo.deviceInstanceId as String?,
                m2mToken = jsRequestInfo.m2mToken as String
            )
            offersApi.requestOfferIdByLinkingPin(requestInfo, traceId = traceId)
        }
    }

    private fun <T : Any> handleOffersJsException(ex: Exception, data: JsExceptionInfo<T>? = null): OffersResult.Error {
        return OffersResult.Error(ResponseHeaders.Invalid, Exception(jsRequestExceptionError))
    }

}
